import { Injectable } from "@angular/core";
import { CanLoad, Route, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { filter, take, timeout, catchError } from "rxjs/operators";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";

@Injectable()
export class AuthGuard implements CanLoad {
  constructor(
    private siAuthenticationService: SiAuthenticationService,
    private router: Router
  ) {}
  /**
   * Activation function for authentication
   * @returns boolean
   */
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (
      this.siAuthenticationService.authStatus.getValue() &&
      (this.siAuthenticationService.getWebToken() ||
        this.siAuthenticationService.getAuthToken())
    ) {
      return true;
    }
    this.router.navigate(["./home"]);
    return false;
  }

  /**
   * checks if can load the page
   * @param route
   * @returns load
   */
  private readonly STANDALONE_PATHS = ['auditlog'];

  canLoad(route: Route): Observable<boolean> | boolean {
    const hasToken = !!(this.siAuthenticationService.getWebToken() || this.siAuthenticationService.getAuthToken());

    // Standalone routes: if token exists but authStatus not yet resolved, validate async
    if (this.STANDALONE_PATHS.includes(route['path'])) {
      if (this.siAuthenticationService.authStatus.getValue() && hasToken) {
        return true;
      }
      if (hasToken) {
        // checkTokenNew() returns void — it only updates authStatus internally.
        // Wait for authStatus to emit a non-false value (true = valid, false = expired).
        this.siAuthenticationService.checkTokenNew();
        return this.siAuthenticationService.authStatus.pipe(
          filter(status => status === true),
          take(1),
          timeout(5000),
          catchError(() => {
            this.router.navigate(['/kclogoutredirect'], { queryParams: { logout: true } });
            return of(false);
          })
        );
      }
      this.router.navigate(['home']);
      return false;
    }

    // Check if user is Authenticated and the Token exists
    if (
      this.siAuthenticationService.authStatus.getValue() &&
      (this.siAuthenticationService.getWebToken() ||
        this.siAuthenticationService.getAuthToken())
    ) {

      const customerMatch = this.siAuthenticationService
        .getCustomerList()
        .some((customer) => {
          // Since getCustomerList() returns formatted Name e.g. C&B , while the URL has unformatted name e.g. frontier
          return (
            this.siAuthenticationService.getUnformattedCustomerName(
              customer
            ) === route["path"]
          );
        });

      if (customerMatch) {
        // If CustomerList contains the customerName, but is not the activeCustomer
        // And the user is trying to directly modify the URL with a customerName
        // (which is present in CustomerList, but not the active Customer)
        if (
          this.siAuthenticationService.activeCustomer.getValue() !==
          route["path"]
        ) {
          this.siAuthenticationService.getCustomerList().forEach((customer) => {
            if (
              this.siAuthenticationService.getUnformattedCustomerName(
                customer
              ) === route["path"]
            ) {
              this.siAuthenticationService.setActiveCustomer(customer);
            }
          });
        }
        return true;
      } else {
        return false;
      }
    } else if (
      this.siAuthenticationService.getWebToken() ||
      this.siAuthenticationService.getAuthToken()
    ) {
      this.siAuthenticationService.checkTokenNew().subscribe({
        next: (response) => {},
        error: (error) => {
        //  this.router.navigate([CONFIG["loginRoute"]]);
        this.router.navigate(['/kclogoutredirect'], { queryParams: {logout : true}});
        },
      });
    } else {
      this.router.navigate(["home"]);
    }
  }
}
